module.exports = "Access to microphone and camera was not provided.<br/>\r\nPlease grant access to your devices.\r\n"